import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const FETCH_STOCK_EVENT_LIST_API_ID = 'DASHBOARD/FETCH_STOCK_EVENT_LIST_API_ID';

const apiCall = createApiCall(FETCH_STOCK_EVENT_LIST_API_ID, params => ({
  endpoint: generateEndpoint({
    host: `/api/admin/stock-events`,
    params,
  }),
  method: 'GET',
}));

export default apiCall;
